import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "swiper/css/swiper.css";
// import VConsole from "vconsole/dist/vconsole.min";
// new VConsole();
import JsBridge from "@/utils/jsBridge.js";
// import VConsole from "vconsole";
// new VConsole();
console.log("JsBridge", JsBridge);
/**
 * JsBridge = {xfpyappH5Js, xfpyappJsBridge}
 */
window.JsBridge = JsBridge;
function listen() {
  if (document.readyState === "complete") {
    // 资源加载完成
    ReactDOM.render(<App />, document.getElementById("root"));
  } else {
    // 资源加载中
    ReactDOM.render(<div></div>, document.getElementById("root"));
  }
}

document.onreadystatechange = listen;
